var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SingleBannerComponent"},[_c('v-container',[_c('div',[_c('v-img',{attrs:{"ml-0":"","px-0":"","src":_vm.image,"max-width":"800","px":"","contain":""}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }